<template>
  <div>
    <Modal v-model="openForm" :title="title + '（' + tableForm.carNo + '）'" footer-hide fullscreen>
      <div id="sdfcsdg">
        <div class="fasfds" v-for="(x, index) in mmedias" :key="index">
          <div id="asaalarm">
            <div class="alarmListTop">
              <Tag color="red">{{ x.alarmTypeName }}</Tag>
              <Tag color="blue">{{ utils.time(x.alarmTime) }}</Tag>
              <Button @click="openMapFun(x)" type="success" size="small">证据截图</Button>
            </div>
            <ul>
              <li v-for="(row, yindex) in x.fileList" :key="yindex">
                <div class="asawrap">


                  <img @click="scanimg(row)" v-if="row.fileType == 0" :src="row.filePath" />

                  <video controls autoplay :src="row.filePath" @click="bofang(row)" type="md-play"
                    v-if="row.fileType == 1 || row.fileType == 2"></video>
                </div>

                <div class="asatext">
                </div>
              </li>
              <li>
                暂无附件
              </li>
            </ul>
          </div>

        </div>
      </div>
    </Modal>

    <viewer v-show="false">
      <img :src="imgsrc" width="50" height="50" ref="img" />
    </viewer>
    <Modal v-model="openVideo" width="760" title="视频/音频" footer-hide @on-cancel="stop">
      <video id="video" width="728" controls></video>
    </Modal>
    <Modal v-model="openMap" fullscreen title="视频/音频" footer-hide @on-cancel="stop">
      <div id="vfujian">
        <div class="vfujianleft">
          <ul id="asaalarm">
            <li style="width: 30%" v-for="(row, index) in medias" :key="index">
              <div class="asawrap">


                <img @click="scanimg(row)" v-if="row.fileType == 0" :src="row.filePath" />

                <video controls autoplay :src="row.filePath" @click="bofang(row)" type="md-play"
                  v-if="row.fileType == 1 || row.fileType == 2"></video>
              </div>

              <div class="asatext">

              </div>
            </li>
          </ul>
        </div>
        <div class="vfujianright">
          <my-map ref="locus" :isNavg="true" type="car">


          </my-map>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import myMap from "../map/locusMap.vue";
export default {
  components: { myMap },
  data() {
    return {
      openForm: false,
      openVideo: false,
      openMap: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "文件名",
          key: "fileName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "文件大小/B",
          key: "fileSize",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "文件类型",
          key: "fileType1",

          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "上传类型",
          key: "uploadType1",

          minWidth: 100,
          maxWidth: 200,
        },

        {
          title: "上传状态",
          key: "uploadState1",

          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "上传时间",
          key: "uploadTime1",

          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "记录时间",
          key: "recordTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.recordTime));
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "查看",
          slot: "media",
          width: 70,
          fixed: "right",
        },
        {
          title: "下载",
          slot: "action",
          width: 70,
          fixed: "right",
        },
      ],
      tableData: [],
      total: 0,

      title: '',
      imgsrc: '/static/photo.jpg',
      tableForm: {
        carNo: ''
      },
      searchItem: {
        "deviceId": 4261,
        "endTime": new Date(2024, 7).getTime(),
        "evetType": "1",
        "startTime": new Date(2024, 6).getTime()
      },
      medias: [],
      mmedias: [
        {
          startTime: 0,
          alarmTypeName: '疲劳驾驶',
          fileList: [
            {
              "id": "1806604127646904321",
              "deviceNo": "14430071250",
              "alarmId": "20240628162238604",
              "fileName": "00_07_6503_0_20240628162238604.jpg",
              "fileType": 0,
              "fileSize": 38098,
              "filePath": "https://v.ly-gps.com/files/alarm_files/202406/14430071250_240628161925_1/00_07_6503_0_20240628162238604.jpg",
              "uploadType": 0,
              "uploadState": 1,
              "uploadTime": 1719562966000,
              "recordTime": 1719562765000,
              "fileType1": "图片",
              "uploadType1": "正常",
              "uploadState1": "已上传",
              "uploadTime1": "2024-06-28 16:22:46"
            },
            {
              "id": "1806604127646904321",
              "deviceNo": "14430071250",
              "alarmId": "20240628162238604",
              "fileName": "00_07_6503_0_20240628162238604.jpg",
              "fileType": 0,
              "fileSize": 38098,
              "filePath": "https://v.ly-gps.com/files/alarm_files/202406/14430071250_240628161925_1/00_07_6503_0_20240628162238604.jpg",
              "uploadType": 0,
              "uploadState": 1,
              "uploadTime": 1719562966000,
              "recordTime": 1719562765000,
              "fileType1": "图片",
              "uploadType1": "正常",
              "uploadState1": "已上传",
              "uploadTime1": "2024-06-28 16:22:46"
            },
            {
              "id": "1806604127646904321",
              "deviceNo": "14430071250",
              "alarmId": "20240628162238604",
              "fileName": "00_07_6503_0_20240628162238604.jpg",
              "fileType": 0,
              "fileSize": 38098,
              "filePath": "https://v.ly-gps.com/files/alarm_files/202406/14430071250_240628161925_1/00_07_6503_0_20240628162238604.jpg",
              "uploadType": 0,
              "uploadState": 1,
              "uploadTime": 1719562966000,
              "recordTime": 1719562765000,
              "fileType1": "图片",
              "uploadType1": "正常",
              "uploadState1": "已上传",
              "uploadTime1": "2024-06-28 16:22:46"
            },
            {
              "id": "1806604127646904321",
              "deviceNo": "14430071250",
              "alarmId": "20240628162238604",
              "fileName": "00_07_6503_0_20240628162238604.jpg",
              "fileType": 0,
              "fileSize": 38098,
              "filePath": "https://v.ly-gps.com/files/alarm_files/202406/14430071250_240628161925_1/00_07_6503_0_20240628162238604.jpg",
              "uploadType": 0,
              "uploadState": 1,
              "uploadTime": 1719562966000,
              "recordTime": 1719562765000,
              "fileType1": "图片",
              "uploadType1": "正常",
              "uploadState1": "已上传",
              "uploadTime1": "2024-06-28 16:22:46"
            }
          ],

        },

      ]
    };
  },
  methods: {
    open(v) {
      console.log(v);

      this.openForm = true;
      this.searchItem.evetType = v.evetType;
      this.searchItem.deviceId = v.deviceId;
      this.searchItem.startTime = v.startTime;
      this.searchItem.endTime = v.endTime;
      this.tableForm = v;


      this.getList();

    },
    getList() {

      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.alarm + "/alarmAsc/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          console.log('返回的详情', data);
          this.mmedias = data;
        }
      });
    },

    bofang(v) {
      return;
      this.openVideo = true;
      var video = document.getElementById("video");
      video.src = v.filePath;
      video.play();

    },
    scanimg(v) {
      this.imgsrc = v.filePath;
      this.$refs.img.click();
    },
    stop() {
      var video = document.getElementById("video");
      video.pause();
    },
    chaguiji() {
      let params = {
        deviceNo: this.tableForm.deviceNo, //终端号
        returnCoord: 2, //1-WGS84，2-GCJ-02，3-BD-09）
        startTime: this.tableForm.startTime-60000, //开始时间（时间戳，精确至秒）
        endTime: this.tableForm.endTime+60000, //结束时间（时间戳，精确至秒）
        startTime1: this.utils.time(this.tableForm.startTime), //开始时间（时间戳，精确至秒）
        endTime1: this.utils.time(this.tableForm.endTime),
      };
      console.log(params);
      this.axios({
        method: "post",
        //url: this.axios.lbs + "/locus/getPlyLocus",
        url: this.axios.lbs + "/locus/getOrgLocus",
        data: params,
      }).then((res) => {
        console.log(res);
        var data = res.data.data.dataList;
        this.tableData = data;
        if (res) {
          if (data.length >= 1) {
            var lnglat = [];
            for (let i = 0; i < data.length; i++) {

              lnglat.push([data[i].returnX, data[i].returnY]);
              //data[i].tms = data[i].gpsTime / 1000;
              data[i].locateLng = data[i].returnX;
              data[i].locateLat = data[i].returnY;
              data[i].gpsTime1 = this.utils.time(data[i].gpsTime);
              data[i].accStatus1 = this.$t("accStatus." + data[i].accStatus);
              /* if (data[i].speed == 0) {
                data[i].parkDuration = 5;
              } */

            }

            this.$refs.locus.loadUi(lnglat, data); //渲染轨迹

            setTimeout(() => {
              this.$refs.locus.showWin(data[0]);
            }, 500);

            //this.$refs.locus.showpark(data, 3); //停车点
          } else if (data.length == 0) {
            this.$Message.error("暂无轨迹");
            this.$refs.locus.loadUi([], []); //清空轨迹
            this.$refs.locus.showpark([], 0); //清空停车点
            //this.$refs.locus.showPoints(this.list);
            this.$store.state.control = false;
          }
        }
      })
    },
    openMapFun(x) {
      this.openMap = true;
      this.medias = x.fileList;
      this.chaguiji();
    }
  },
};
</script>
<style>
#vfujian {
  width: 100%;
  height: 100%;
  display: flex;
}

#vfujian .vfujianleft {
  width: 61.8%;
  height: 100%;
  overflow: auto;
}

#vfujian .vfujianleft ul {
  display: flex;
  flex-wrap: wrap;
}

#fujian .asawrap {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #333;
}

#vfujian .vfujianright {
  width: 37.8%;
  height: 100%;
  background: red;
}


#asaalarm ul {
  display: flex;
  flex-wrap: wrap;
}

#asaalarm .alarmListTop {
  margin-bottom: 10px;
  border-bottom: solid 2px #67a5f5;
  padding-bottom: 4px;
}

#asaalarm li {
  width: 200px;
  margin: 0 10px 30px 10px;
}

#asaalarm .asawrap {
  width: 100%;
  aspect-ratio: 16 / 12;
  background: #333;
}

#asaalarm .asawrap img,
#asaalarm .asawrap video {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

#asaalarm .asatext {
  line-height: 1.5;
}

#asaalarm .asatext p:first-child {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/alarm/ascSelectFujian.vue